<template>
  <div class="mx-4 px-3 pt-5">
    <!-- <h2 xs8 sm8 md8 class="pl-4 py-3">Add New Location</h2> -->
    <v-container fluid px-0 py-0 ma-4>
      <v-layout row wrap>
        <v-flex xs12 sm6>
          <!-- <label>Name</label>           -->
            <!-- placeholder="Location Name" -->
          <v-text-field outline
            v-model="artwork_location.name"
            label="Location Name"
            @input.native="$emit('input',$event.target.value)"
            @keyup="check_location($event.target.value)"
          ></v-text-field>
          <div v-if="location_exists">This Location already exists!</div>
          <div v-if="saved">Location was saved!</div>
          <div v-if="cannotSave">Location already exists! Cannot save!</div>
        </v-flex>
          <!-- <edit-field v-for="(field, index) in fields"
            :class="'flex d-flex ' + field.class"
            :key="index"
            :value="artistFormData[field.name]"
            :field="field"
            :artist="artistFormData"
            @input="updateForm(field.name, $event.value)"
            >
          </edit-field> -->
        <!-- <v-btn :disabled="!valid" @click="submit" > submit </v-btn>
        <v-btn @click="clear">clear</v-btn> -->
        <!-- </v-flex> -->
        <v-btn color="primary" @click.native="saveLocation">Save</v-btn>
        <v-btn flat>Cancel</v-btn>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import axios from 'axios'
  // import * as qs from "querystring";
  export default {
    data () {
      return {
        artwork_location: { name: '' },
        // fields: [
        //   {
        //     'name': {
        //       'ctype': 'text-short',
        //       'name': 'name',
        //       'title': 'Name',
        //       'class': 'xs12 md6'
        //     }
        //   }
        // ],
        // artistFormData: Object.assign({},this.artist),
        valid: true,
        location_exists: false,
        cannotSave: false,
        saved: false
      }
    },
    methods: {
      check_location (value) {
        var a = Object.assign([],this.$store.state.artwork_locations)
        var b = a.filter(aa => aa.name == value)
        this.location_exists = b.length > 0
      },
      // submit () {
      //   // const art = this.artistFormData
      //   const requestConfig = {
      //       url     : `${this.$globals.apiserver}/artwork_locations.json`,
      //       method  : "POST",
      //       // headers : { "Content-Type" : "application/x-www-form-urlencoded" },
      //       // data : qs.stringify(art)
      //       artwork_location: this.location
      //   }
      //   const response = axios.request(requestConfig)
      // },
      saveLocation () {
        
        this.artwork_location.created_by = this.c_user.id
        
        let url = `${this.$globals.apiserver}/artwork_locations.json`

        axios.post(url,this.artwork_location).then((response) => {
          this.result = response.data
          this.artwork_location = response.data
          // this.$store.dispatch('addExhibition',response.data)
          this.e1 = 2
        })
        .then(response => {
          this.$store.dispatch("loadLocations");
          this.$emit("showSnackbar", "Location '" + this.artwork_location.name + "' Saved ", "green");
          this.progress = false;
          this.isEditing = false;
          this.$router.push({ name: "Locations" });
        }).catch((error) => { 
          this.$emit("showSnackbar", "Problem saving Location '" + this.artwork_location.name + "' ", "red");
          // console.log(error);
        })
      },      
      clear () {
        this.$refs.form.reset()
      }
    },
    computed: {
    },
  }
</script>

<style scoped>
  h1 { font-size: 1em !important; margin-left: 10px; }
  small {font-size:1em; float:left; display: block;}
  .v-tabs-bar {top: 200px;position: fixed;z-index: 1;} 
  .toolbar {margin-top: 0px;top: 80px;position: fixed;z-index: 1;}
  div.tabs__bar.theme--dark.grey {margin-top: 0px;top: 200px;position: fixed;z-index: 1;}
  .tabs__items {margin-top: 120px;}
</style>


// WEBPACK FOOTER //
// src/components/locations/AddLocation.vue